<script setup>
import { computed } from 'vue'
import Icons from '@icons'

const props = defineProps({
    name: {
        type: String,
    },
    size: {
        type: String,
        default: '20px',
    },
    width: {
        type: String
    },
    height: {
        type: String
    }
})

const Icon = computed(() => {
    if (props.name) {
        return Icons[props.name] || false
    }

    return Icons['chevronDown']
})

</script>

<template>
    <div class="inline-flex items-center justify-center prebook-icon" v-bind="$attrs" :style="`width: ${props.width || props.size}; height: ${props.height || props.size};`">
        <component v-if="Icon" :is="Icon"></component>
        <span v-else>{{ props.name }}</span>
    </div>
</template>